import { useState } from "react";
import useShowDialogAlert from "components/DialogAlert/utils/hooks/useDialogAlert";
import { ACTION_TYPES } from "../constants";
import useResourcesUniversitySpacesContext from "views/Recursos/ResourcesUniversitySpaces/utils/context/useResourcesUniversitySpacesContext";
import { requestDeleteStudentsFromSpaceReservation, requestValidateDeletionStudentInSpaceReservation } from "services/resources/universitySpaces/aboutUniversitySpaceResources";

const useDeleteStudents = ({
    selectedStudents,
    setStudentsSelectedToUse,
    dialogs: {
        dialogShowNotActionForHavingAttendanceOrPenalty
    },
    setActionTypeOfNoActionForHaveAttendanceOrPenalty,
    addActionTypeToListActions
}) => {
    const { loadingRequestOfReservationAction } = useResourcesUniversitySpacesContext();
    //#region Hooks
    const dialogShowDeleteStudentsConfirmation = useShowDialogAlert();
    const dialogShowNotDeleteForMinStudentsRemaining = useShowDialogAlert();
    const dialogDeleteStudentSuccessfully = useShowDialogAlert(); 
    const dialogMinCapacityReached = useShowDialogAlert();
    //#endregion
    //#region States
    const [studentReservationDetailIdsToDelete, setStudentReservationDetailIdsToDelete] = useState([]);
    const [studentsWithPenaltyOrAttendanceForDeletion, setStudentsWithPenaltyOrAttendanceForDeletion] = useState([]);
    //#endregion
    //#region Functions
    function getStudentReservationDetailIdsFromStudentsToDelete(studentsToDelete) {
        return studentsToDelete
            .filter(({ reservationDetailId, saved }) => reservationDetailId && saved)
            .map(({ reservationDetailId }) => reservationDetailId);
    }
    const deleteStudentsFromReservationList = () => {
        dialogShowDeleteStudentsConfirmation.hide();
        const studentsToDelete = selectedStudents.getSelectedStudentsFromList();
        setStudentsSelectedToUse(studentsToDelete);
        setStudentReservationDetailIdsToDelete(
            getStudentReservationDetailIdsFromStudentsToDelete(studentsToDelete)
        );
        dialogDeleteStudentSuccessfully.open();
        selectedStudents.removeSelectedStudentsFromList();
        selectedStudents.unselectAllStudents();
        addActionTypeToListActions(ACTION_TYPES.DELETE);
    }
    const isValidDeletion = async () => {
        const savedSelectedStudents = selectedStudents.getSavedSelectedStudents();
        if (savedSelectedStudents.length === 0) return true;
        loadingRequestOfReservationAction.show("Validando...");
        const success = await requestValidateDeletionStudentInSpaceReservation({ 
            reservationDetailIds: savedSelectedStudents.map(({ reservationDetailId }) => reservationDetailId) 
        });
        loadingRequestOfReservationAction.hide();
        let newStudentsWithPenaltyOrAttendanceForDeletion = [];
        if (!success)
            newStudentsWithPenaltyOrAttendanceForDeletion = savedSelectedStudents
                .filter(({ attended, penalty }) => attended || penalty);
        setStudentsWithPenaltyOrAttendanceForDeletion(newStudentsWithPenaltyOrAttendanceForDeletion);
        return success;
    }
    const openDeleteStudentDialog = async () => {
        if (!await isValidDeletion()) {
            dialogShowNotActionForHavingAttendanceOrPenalty.open();
            setActionTypeOfNoActionForHaveAttendanceOrPenalty(ACTION_TYPES.DELETE);
            return;
        }
        dialogShowDeleteStudentsConfirmation.open()
    }
    const doRequestDeleteStudentFromReservationList = async () => {
        loadingRequestOfReservationAction.show("Eliminando alumno(s)...");
        const { success } = await requestDeleteStudentsFromSpaceReservation({
            reservationDetailIds: studentReservationDetailIdsToDelete
        });
        loadingRequestOfReservationAction.hide();
        if (!success) 
            throw new Error();
    }
    //#endregion
    return {
        studentReservationDetailIdsToDelete,
        studentsWithPenaltyOrAttendanceForDeletion,
        fns: {
            deleteStudentsFromReservationList,
            openDeleteStudentDialog,
            doRequestDeleteStudentFromReservationList
        },
        dialogs: {
            dialogShowDeleteStudentsConfirmation,
            dialogShowNotDeleteForMinStudentsRemaining,
            dialogMinCapacityReached,
            dialogDeleteStudentSuccessfully
        }
    };
}	
    
export default useDeleteStudents;